export default __webpack_public_path__ + "static/media/SB-BIOLOGY-HIGH-SCHOOL-AP-U4.9d752bb8.jpg";